// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--2_cQP";
export var Name = "styles-module--Name--LjmJ6";
export var PropertyList = "styles-module--PropertyList--1f_Fl";
export var Label = "styles-module--Label--1yaWX";
export var Accordion = "styles-module--Accordion--2RRop";
export var Accordion_Opened = "styles-module--Accordion_Opened--163ht";
export var Accordion_Closed = "styles-module--Accordion_Closed--3Or_3";
export var RoomPlanItem = "styles-module--RoomPlanItem--2TUUN";
export var RoomPlanItem_Name = "styles-module--RoomPlanItem_Name--30tAK";
export var RoomPlanItem_Layout = "styles-module--RoomPlanItem_Layout--3LMWT";
export var RoomPlanItem_Dod = "styles-module--RoomPlanItem_Dod--3NrYV";
export var RoomPlanItem_Link = "styles-module--RoomPlanItem_Link--1UexK";
export var RoomPlanItemIcon = "styles-module--RoomPlanItemIcon--2srHX";
export var RoomPlanItemIcon_Delete = "styles-module--RoomPlanItemIcon_Delete--2IqO2";
export var RoomPlanItemIcon_Add = "styles-module--RoomPlanItemIcon_Add--1qi7l";
export var RoomPlanItemLast = "styles-module--RoomPlanItemLast--1dna_";
export var HeaderItem = "styles-module--HeaderItem--2u3x3";
export var LinkToTopPage = "styles-module--LinkToTopPage--3zcEE";
export var HeaderItem_Text = "styles-module--HeaderItem_Text---6r7Z";
export var ExpandButton = "styles-module--ExpandButton--2XyT0";
export var ExpandButtonIcon = "styles-module--ExpandButtonIcon--tmRA6";
export var LinkToTopPage_Text = "styles-module--LinkToTopPage_Text--3DIjF";
export var RoomInformation = "styles-module--RoomInformation--1wUPZ";